export const RECEIVER = '410013217362715';
export const LABEL_PREFIX = 'doshkonkurs-vk-order-id-';
export const ORDER_FALLBACK_PRICE = 110;